import React from 'react';
import { useNavigate } from 'react-router-dom';

import { SvgCardType } from '../../components/svg-card/svg-card-types';
import { urler } from '../../router/router-urler';
import { RadioAlternativ } from '../../sporsmalsflyt/reducer/sporsmalsflyt-types';
import { Skademeldingstype } from '../../types/generated-types';
import { skadeUrlFromSkadetype } from '../../urler';
import { GruppeLandingsside } from '../gruppe-landingsside';
import { KategoriSvarId } from '../sporsmal-og-svar';

const alternativer: RadioAlternativ[] = [
    {
        id: KategoriSvarId.BygningInnbrudd,
        tekst: 'Innbrudd',
    },
    {
        id: KategoriSvarId.BygningHarverk,
        tekst: 'Hærverk',
    },
];

export const BygningInnbruddOgHarverk = () => {
    const navigate = useNavigate();

    const onNext = (svarId: string) => {
        if (svarId === KategoriSvarId.BygningInnbrudd) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.BygningInnbrudd));
        } else if (svarId === KategoriSvarId.BygningHarverk) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.BygningHarverk));
        }
    };

    const goback = () => navigate(urler().husOgHytteUrl);

    return (
        <GruppeLandingsside
            title="Innbrudd og hærverk"
            onNext={onNext}
            navigateToParent={goback}
            alternativer={alternativer}
            svgCardType={SvgCardType.HusEnkelt}
            radioButtonsLabel="Hva har skjedd?"
            kategoriId="bygning-innbrudd-harverk"
        />
    );
};
